import styles from "./TonjeImage.module.scss";
const TonjeImage = ({ src, alt, round }) => (
  <div className={`${styles.wrapper} ${round && styles.round} `}>
    <img src={src} alt={alt} />
  </div>
);

export default TonjeImage;
